import {useEffect, useRef} from 'react'
import useInterval from './useInterval'
import printOrder from './Print/printOrder'
import {getScheduledDeliveryTS, getReminderPoints, isDriverChoiceMade} from './scheduledDelivery'

// Resurfaces scheduled delivery orders that still have no driver choice:
// rings like a new order on every tablet, and prints on whichever app claims it first.
export default function useScheduledReminders ({r_id, ordersSnapshot, settings, newOrdersDispatch}) {
  const rungRef = useRef(new Set())

  function claimAndPrint (orderSnap, pointKey) {
    if (!window.ReactNativeWebView) { return } // only the tablet app can print
    if (r_id === 'kiin') { return }
    orderSnap.ref.child(`reminderPrints/${pointKey}`)
      .transaction((claimedTS) => claimedTS ? undefined : Date.now())
      .then(({committed}) => {
        if (!committed) { return }
        printOrder({order: orderSnap.val(), id: orderSnap.key, context: 'NEW_ORDER'})
      })
      .catch((e) => console.log('reminder print claim failed', e))
  }

  function checkReminders () {
    if (!ordersSnapshot) { return }
    const now = Date.now()
    const dueOrders = []
    ordersSnapshot.forEach((orderSnap) => {
      const order = orderSnap.val() || {}
      if (order.hideFromStaff || order.canceled) { return }
      const scheduledTS = getScheduledDeliveryTS(order)
      if (!scheduledTS || now > scheduledTS) { return }
      if (isDriverChoiceMade(order, settings)) { return }
      getReminderPoints(order).forEach(({key, ts}) => {
        const ringKey = `${orderSnap.key}:${key}`
        if (now < ts || rungRef.current.has(ringKey)) { return }
        rungRef.current.add(ringKey)
        if (dueOrders.indexOf(orderSnap) === -1) { dueOrders.push(orderSnap) }
        claimAndPrint(orderSnap, key)
      })
    })
    if (dueOrders.length > 0) {
      newOrdersDispatch({type: 'add', newOrders: dueOrders})
    }
  }

  useEffect(checkReminders, [ordersSnapshot, settings])
  useInterval(checkReminders, 30 * 1000)
}
